import React, { Component } from "react";
import ValidationRules from "../../../../common/ValidationRules";
import { withTranslation } from "react-i18next";
import { logMsg } from "../../../../common/Logger";
import { DELIVERY_BANDS } from "../../../../common/Constants";
import PendingActionPrompt from "../../../../shared/pendingActionPrompt/PendingActionPrompt";
import PendingActionClient from "../../../../shared/clients/PendingActionClient";
import { EffectiveDateBand } from "./EffectiveDateBand";
import DeliveryRangeTable from "./DeliveryRangeTable";
import DeliveryRangeHeader from "./DeliveryRangeHeader";
import DealerDeliveryRangesClient from "../../../../shared/clients/DealerDeliveryRangesClient";
import UiDateUtils from "../../../../utils/UiDateUtils";

class DealerDeliveryRanges extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldDeliveryData: {},
      deliveryData: {},
      isOldEditActive: false,
      isNewEditActive: false,
      enableOldSaveButton: true,
      enableNewSaveButton: true,
      dataLoaded: false,
      pendingActionPrompt: false,
    };
    this.currencySymbol =
      this.props.localizedInfo && this.props.localizedInfo.defaultCurrency
        ? this.props.localizedInfo.defaultCurrency.symbol
        : "NA";
    this.distanceUnit =
      this.props.localizedInfo && this.props.localizedInfo.defaultDistanceUnit
        ? this.props.localizedInfo.defaultDistanceUnit
        : "NA";

    this.onboardedDealers = this.props.user.getOnboardedDealerGroup(true);
    this.fromNsc = false;
  }

  componentDidMount = async () => {
    ValidationRules();
    await this.determinePAStatus();
    await this.getDeliveryRanges();
  };

  handlePriceChange = (e, index, old) => {
    const deliveryData = this.copyDeliveryData(old);
    deliveryData.deliveryRangeOptions[index].value = e.target.value;
    this.setStateForData(deliveryData, old);
  };

  handleDeliveryChargeChange = (e, old) => {
    const deliveryData = this.copyDeliveryData(old);
    deliveryData.nonMainlandDeliveryCharge = e.target.value;
    this.setStateForData(deliveryData, old);
  };

  handleInternationalCharge = (e, old) => {
    const deliveryData = this.copyDeliveryData(old);
    deliveryData.deliverInternationalCharge = e.target.value;
    this.setStateForData(deliveryData, old);
  };

  handleSave = (old) => {
    const deliveryData = this.copyDeliveryData(old);

    deliveryData.deliveryRangeOptions.filter((range) => {
      return range.acceptedByDealer === true;
    });

    deliveryData.saveToOld = old;
    this.dataToSendToDialog = deliveryData;

    if (
      this.props.user.showAll &&
      this.onboardedDealers.length > 1 &&
      !this.disablePendingActionPrompt
    ) {
      this.setState({ pendingActionPrompt: true });
    } else {
      this.saveDeliveryRanges(
        this.dataToSendToDialog,
        this.props.user.getDealerIdsWithoutSDLR(),
        old
      );
    }
  };

  handleRangesFromEmp(data, setAsOld) {
    this.setStateForRanges(data, setAsOld);
  }

  setStateForRanges(deliveryData, setAsOld) {
    let foundFirstFalse = false;
    if (deliveryData) {
      deliveryData.nonMainlandDeliveryCharge =
        deliveryData.nonMainlandDeliveryCharge
          ? deliveryData.nonMainlandDeliveryCharge.toFixed(2)
          : "0";
      deliveryData.deliverInternationalCharge =
        deliveryData.deliverInternationalCharge
          ? deliveryData.deliverInternationalCharge.toFixed(2)
          : "0";
      deliveryData.deliveryRangeOptions.sort(
        (a, b) => parseFloat(a.from) - parseFloat(b.from)
      );
      deliveryData.deliveryRangeOptions.forEach((range) => {
        range.value = range.value.toFixed(2);
        if (!range.acceptedByDealer) {
          if (foundFirstFalse) {
            range.disabled = true;
          } else {
            range.disabled = false;
            foundFirstFalse = true;
          }
        } else {
          range.disabled = false;
        }
      });

      this.fromNsc = !setAsOld && deliveryData.fromNsc;

      setAsOld
        ? this.setState({ oldDeliveryData: deliveryData })
        : this.setState({ deliveryData: deliveryData }, () => {
            this.freeDeliveryToggle(setAsOld, true);
          });
    }
  }

  fetchDeliveryRangesFromEmp(market) {
    return DealerDeliveryRangesClient.getDealerDeliveryRangesNew(
      this.props.user,
      market
    )
      .then((data) => {
        return data;
      })
      .catch((err) => {
        logMsg("err", err);
      })
      .finally(() => {
        this.setState({ dataLoaded: true });
      });
  }

  getDeliveryRanges = async () => {
    this.props.hideOrShow(true);
    const market = this.props.user.market;
    const empData = await this.fetchDeliveryRangesFromEmp(market);

    this.handleRangesFromEmp(empData && empData.result, true);
    this.handleRangesFromEmp(empData && empData.newResult, false);

    this.props.hideOrShow(false);
  };

  copyDeliveryData(old) {
    return old
      ? JSON.parse(JSON.stringify(this.state.oldDeliveryData))
      : JSON.parse(JSON.stringify(this.state.deliveryData));
  }

  deliverInNonMainLandToggle = (old) => {
    const deliveryData = this.copyDeliveryData(old);
    const deliveryDataState = this.getDeliveryDataState(old);

    deliveryData.nonMainlandDelivery = !deliveryDataState.nonMainlandDelivery;
    this.setStateForData(deliveryData, old);
    this.enableSave(old);
  };

  sellInternationalToggle = (old) => {
    const deliveryData = this.copyDeliveryData(old);
    const deliveryDataState = this.getDeliveryDataState(old);

    deliveryData.sellInternational = !deliveryDataState.sellInternational;
    deliveryData.deliverInternational = false;
    this.setStateForData(deliveryData, old);
    this.enableSave(old);
  };

  deliverInternationalToggle = (old) => {
    const deliveryData = this.copyDeliveryData(old);
    const deliveryDataState = this.getDeliveryDataState(old);

    deliveryData.deliverInternational = !deliveryDataState.deliverInternational;
    this.setStateForData(deliveryData, old);
    this.enableSave(old);
  };

  freeDeliveryToggle = async (old, initial) => {
    const deliveryData = this.copyDeliveryData(old);
    const deliveryDataState = this.getDeliveryDataState(old);
    if (!initial) {
      deliveryData.freeDelivery = !deliveryDataState.freeDelivery;
    }
    await this.setStateForData(deliveryData, old);
    await this.updateToggleStatus(0, old, deliveryData.freeDelivery, initial);
  };

  enableSave = (old) => {
    old
      ? this.setState({ enableOldSaveButton: true })
      : this.setState({ enableNewSaveButton: true });
  };

  disableSave = (old) => {
    old
      ? this.setState({ enableOldSaveButton: false, isOldEditActive: false })
      : this.setState({ enableNewSaveButton: false, isNewEditActive: false });
  };

  updateToggleStatus = (index, old, freeDelivery, initial) => {
    const deliveryData = this.copyDeliveryData(old);
    const deliveryDataState = this.getDeliveryDataState(old);
    const deliveryRanges = deliveryData.deliveryRangeOptions;
    if (deliveryRanges && deliveryRanges[index]) {
      if (freeDelivery === true) {
        deliveryRanges[index].acceptedByDealer = true;
        deliveryRanges[index].disabled = true;
      } else if (freeDelivery === false) {
        deliveryRanges[index].disabled = false;
      } else {
        deliveryRanges[index].acceptedByDealer =
          !deliveryDataState.deliveryRangeOptions[index].acceptedByDealer;
      }

      if (!deliveryRanges[index].acceptedByDealer) {
        for (let i = parseInt(index) + 1; i < deliveryRanges.length; ++i) {
          deliveryRanges[i].acceptedByDealer = false;
          deliveryRanges[i].disabled = true;
        }
      } else {
        // Enable the next toggle
        if (parseInt(index) + 1 < deliveryRanges.length) {
          deliveryRanges[parseInt(index) + 1].disabled = false;
        }
      }

      deliveryData.deliveryRangeOptions = deliveryRanges;

      this.setStateForData(deliveryData, old);
      if (!initial) {
        this.enableSave(old);
      }
    }
  };

  saveDeliveryRanges = (data, dealerIds, old) => {
    let dealerIdsList;
    if (Array.isArray(dealerIds)) {
      dealerIdsList = dealerIds;
    } else {
      dealerIdsList = dealerIds.split(",");
    }

    this.saveDeliveryRangesEMP(data, dealerIdsList, dealerIds, old);
  };

  saveDeliveryRangesEMP(data, dealers, dealerIds, old) {
    this.props.hideOrShow(true);
    if (data.freeDelivery === true) {
      data.deliveryRangeOptions[0].value = 0;
    }
    const deliveryEnabled = old
      ? data.deliveryRangeOptions[0].acceptedByDealer
      : null;
    DealerDeliveryRangesClient.saveDealerDeliveryRangesNew(
      data,
      this.props.user,
      dealers,
      old
    ).then(() => {
      this.removePendingAction(dealerIds, deliveryEnabled);
      this.disableSave(old);
    });
  }

  removePendingAction(dealerIds, deliveryEnabled) {
    PendingActionClient.removeDealerPendingAction(
      this.props.user,
      dealerIds,
      DELIVERY_BANDS,
      null,
      deliveryEnabled
    )
      .then(() => {
        this.getDeliveryRanges();
        this.props.getPendingActions().then(() => {
          this.determinePAStatus();
        });
      })
      .finally(() => {
        this.setState(
          {
            pendingActionPrompt: false,
          },
          () => {
            this.props.hideOrShow(false);
          }
        );
      });
  }

  determinePAStatus() {
    this.pendingActionStatusForDealers =
      this.props.user.getPendingActionStatusForDealers(
        this.props.user.pendingActions,
        "DELIVERY_BANDS"
      );
    this.disablePendingActionPrompt =
      this.pendingActionStatusForDealers.length === 0;
  }

  pendingActionPromptClose = () => {
    this.setState({ pendingActionPrompt: false });
  };

  pendingActionPromptApplyAll = () => {
    const isOldRanges = this.isOldRanges();
    const isNewRanges = this.isNewRanges();
    const old =
      !isOldRanges && isNewRanges
        ? false
        : isOldRanges && !isNewRanges
        ? true
        : null;

    const dealerIds = this.pendingActionStatusForDealers[0].map((dealer) => {
      return dealer.dealerId;
    });
    this.saveDeliveryRanges(this.dataToSendToDialog, dealerIds, old);
  };

  pendingActionPromptApplySelective = () => {
    const isOldRanges = this.isOldRanges();
    const isNewRanges = this.isNewRanges();
    const old =
      !isOldRanges && isNewRanges
        ? false
        : isOldRanges && !isNewRanges
        ? true
        : null;

    const dealerIds = this.pendingActionStatusForDealers[0]
      .filter((dealer) => !dealer.pendingActionStatus)
      .map((dealer) => {
        return dealer.dealerId;
      });
    this.saveDeliveryRanges(this.dataToSendToDialog, dealerIds, old);
  };

  setStateForData = async (data, old) => {
    old
      ? await this.setState({
          oldDeliveryData: data,
        })
      : await this.setState({
          deliveryData: data,
        });
  };

  getDeliveryDataState(old) {
    return old ? this.state.oldDeliveryData : this.state.deliveryData;
  }

  isOldRanges = () => {
    return (
      this.state.oldDeliveryData &&
      this.state.oldDeliveryData.deliveryRangeOptions &&
      this.state.oldDeliveryData.deliveryRangeOptions.length > 0
    );
  };

  isNewRanges = () => {
    return (
      this.state.deliveryData &&
      this.state.deliveryData.deliveryRangeOptions &&
      this.state.deliveryData.deliveryRangeOptions.length > 0
    );
  };

  setEditActive = (old) => {
    old
      ? this.setState((prevState) => ({
          isOldEditActive: !prevState.isOldEditActive,
          enableOldSaveButton: true,
        }))
      : this.setState((prevState) => ({
          isNewEditActive: !prevState.isNewEditActive,
          enableNewSaveButton: true,
        }));
  };

  deliveryBody = () => {
    const isOldRanges = this.isOldRanges();
    const isNewRanges = this.isNewRanges();

    if (isOldRanges && isNewRanges) {
      return (
        <>
          {this.deliveryBodyTable(true, true)}
          <EffectiveDateBand
            text={this.props.t("nscDeliveryBands.newZonesEffectiveHeader")}
            date={
              this.state.deliveryData.effectiveDate &&
              UiDateUtils.formatYYYYMMDDToEUWithoutTime(
                this.state.deliveryData.effectiveDate
              )
            }
            className="pagePaddingTop"
          />
          {this.deliveryBodyTable(false, true)}
        </>
      );
    } else if (!isOldRanges && isNewRanges) {
      return <>{this.deliveryBodyTable(false, true)}</>;
    } else if (isOldRanges && !isNewRanges) {
      return <>{this.deliveryBodyTable(true, true)}</>;
    } else {
      return null;
    }
  };

  deliveryBodyTable = (old, editable) => {
    return (
      <DeliveryRangeTable
        {...this.props}
        oldDeliveryData={this.state.oldDeliveryData}
        deliveryData={this.state.deliveryData}
        old={old}
        editable={editable}
        onSubmit={this.handleSave}
        distanceUnit={this.distanceUnit}
        isEditActive={
          old ? this.state.isOldEditActive : this.state.isNewEditActive
        }
        currencySymbol={this.currencySymbol}
        editOnClick={this.setEditActive}
        enableSaveButton={
          old ? this.state.enableOldSaveButton : this.state.enableNewSaveButton
        }
        updateToggleStatus={this.updateToggleStatus}
        handlePriceChange={this.handlePriceChange}
        deliverInNonMainLandToggle={this.deliverInNonMainLandToggle}
        handleDeliveryChargeChange={this.handleDeliveryChargeChange}
        sellInternationalToggle={this.sellInternationalToggle}
        deliverInternationalToggle={this.deliverInternationalToggle}
        handleInternationalCharge={this.handleInternationalCharge}
        freeDeliveryToggle={this.freeDeliveryToggle}
      />
    );
  };

  render() {
    const fromNscDealerSearch =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "deliveryRangesSubmit"
      ) && this.props.fromNscDealerSearch;
    return (
      this.state.dataLoaded && (
        <section className="pageWrapper">
          <DeliveryRangeHeader
            {...this.props}
            header={this.props.t("dealerDeliveryBands.header1")}
          />

          {this.deliveryBody()}

          <PendingActionPrompt
            {...this.props}
            disabled={this.disablePendingActionPrompt || fromNscDealerSearch}
            dealersActioned={
              this.disablePendingActionPrompt
                ? []
                : this.pendingActionStatusForDealers[0].filter(
                    (dealer) => dealer.pendingActionStatus
                  )
            }
            dealersNotActioned={
              this.disablePendingActionPrompt
                ? []
                : this.pendingActionStatusForDealers[0].filter(
                    (dealer) => !dealer.pendingActionStatus
                  )
            }
            title={this.props.t("PendingActionPrompt.deliveryRanges")}
            buttonTitle={this.props.t(
              "PendingActionPrompt.deliveryRangesButton"
            )}
            onClose={this.pendingActionPromptClose}
            open={this.state.pendingActionPrompt}
            applyAll={this.pendingActionPromptApplyAll}
            applySome={this.pendingActionPromptApplySelective}
          />
        </section>
      )
    );
  }
}

export default withTranslation("emp")(DealerDeliveryRanges);
